import React from 'react';

export default function ThankYou() {
  return(
    <>
      <header>
        <figure className="logo">
            <img src="img/logo.png" alt=""/>
        </figure>
      </header>
      <div className="conteudo">
        <h1>CADASTRO REALIZADO COM SUCESSO</h1>
        <div className="container">
			    <p>Obrigado por enviar seus dados. Assim que os mesmos forem processados e aprovados, você receberá um e-mail para fazer o upload do filme!</p>
			    <p>Atenciosamente,</p>
          <p>Academia Brasileira de Cinema e Artes Audiovisuais</p>
        </div>
      </div>
    </>
  )
}
